import React, { useEffect } from 'react';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import cx from 'classnames';
// import { v4 as uuid } from 'uuid';
import { color, floatClear } from 'styles/utils';
import { createTheme, withStyles, makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import ErrorIcon from '@material-ui/icons/Error';
import styled, { createGlobalStyle } from 'styled-components';
// NOTE: 사용법

const defaultTheme = createTheme();

function CustomTranslateTooltip(props) {
  const {
    PopperProps = {},
    children = <></>,
    title = <></>,
    placement = '',
    interactive,
    open,
    block,
    disableHoverListener,
    disableFocusListener,
    disableTouchListener,
    className = '',
    left = '',
    top = '',
    width = '',
    onClose = () => {},
  } = props;

  const TranslateTooltip = withStyles({
    tooltip: {
      color: 'black',
      backgroundColor: 'transparent',
      padding: '0',
      margin: '0',
      maxWidth: width,
    },
  })(Tooltip);

  return (
    <ThemeProvider theme={defaultTheme}>
      <Styled.CustomTranslateTooltip
        data-component-name="CustomTranslateTooltip"
        className={cx('customTooltip', { block: block }, className)}
      >
        <Styled.GlobalCurrencySelect left={left} top={top} />
        <TranslateTooltip
          PopperProps={PopperProps}
          title={title}
          // onClose={onClose}
          interactive={interactive}
          placement={placement}
          open={open}
          disableHoverListener={disableHoverListener}
          disableFocusListener={disableFocusListener}
          disableTouchListener={disableTouchListener}
        >
          {children}
        </TranslateTooltip>
      </Styled.CustomTranslateTooltip>
    </ThemeProvider>
  );
}

export default CustomTranslateTooltip;

const Styled = {
  GlobalCurrencySelect: createGlobalStyle`
  .MuiTooltip-popper {
    left: ${({ left }) => `${left} !important`};
    top: ${({ top }) => `${top} !important`};
  }
  `,
  CustomTranslateTooltip: styled.div`
    position: relative;
    display: inline-block;
    ${floatClear};

    &.block {
      width: 100%;
      ${floatClear};
    }
    .tooltip__wapper {
      display: inline-block;
      ${floatClear};
      &.block {
        width: 100%;
        ${floatClear};
      }
    }
  `,
  TootipStyle: styled.div`
    position: relative;
    display: inline-block;
    /* padding: 10px; */
  `,
};

// const theme = createTheme({
//   overrides: {
//     MuiTooltip: {
//       tooltip: {
//         fontSize: "30px",
//         color: "yellow",
//         backgroundColor: "gray"
//       }
//     }
//   }
// });
// const BlueOnGreenTooltip = withStyles({
//   tooltip: {
//     color: "lightblue",
//     backgroundColor: "green"
//   }
// })(Tooltip);
